<template>
 <nav id="top-nav" class="top-nav" :class="{ 'is-shadowed': isShadowed }">
	<h2 class="visually-hidden">Navigation Menu</h2>
	<div class="top-nav-gradient container position-fixed"></div>
	<div class="top-nav-gradient-white container position-fixed"></div>
	<div class="top-nav-solid-white container position-fixed"></div>
	<div class="top-nav-search container position-fixed p-0" id="nav-search-area-container">
		<nav-search-area ></nav-search-area>
	</div>
	<div class="top-nav-container container position-fixed">

		<div class="">

			<div class="top-nav-row align-items-center">

				<a class="hamilton-logo" href="/">
					<span class="bg-icon hamilton-logo-shape"></span>
					<span class="bg-icon hamilton-logo-text"></span>
					<span id="hamilton-logo-section-name" class="hamilton-logo-section-name heading-5"></span>
				</a>
				<div class="empty-space">
				</div>
				<div id="search-button" class="search-icon-holder" tabindex="0"><span class="bg-icon search-icon"></span></div>
				<div class="user-icon-holder" data-show-modal="login-modal" tabindex="0"><span class="bg-icon user-login-icon"></span></div>
				<button id="hamburger-menu" class="menu-icon-holder"><span class="bg-icon menu-icon"></span></button>

			</div>
		</div>


	</div>


 </nav>

</template>

<script>

	import NavSearchArea from "../systems/NavSearchArea.vue";

export default {
	components: {
		NavSearchArea,

	},
	props: {
		isShadowed: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
	.ie {
		.top-nav {
			.hamilton-logo-text {
				position: relative;
				left: 0;
			}
		}
	}

	.top-nav {
		height: 80px;	

		@media print {
			display: none;
		}
		
		.navigation-megadropdown {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}

		.top-nav-search {
			transition: all 0.3s ease;
			top: -90px;
			// display: none;
			z-index: 12;
		}

		.top-nav-container {
			z-index: 11;

			transition: top 0.3s ease;
			top: 0;

			@include respond-below(lg) {
				padding: 0em 1rem !important;

			}
		}
		.top-nav-gradient, .top-nav-gradient-white, .top-nav-solid-white {
			pointer-events: none;
			transition: all 0.3s;
			z-index: 10;
			height: 90px;
		}
		
		//By default, hide all nav
		&.is-shadowed {
			.top-nav-gradient {
				background-image: linear-gradient(to bottom, rgba(0,0,0,0.4) 50%, transparent 100% ), linear-gradient(to bottom, rgba(0,0,0,0.2), transparent 100% );
				opacity: 0.0;
			}

			.top-nav-gradient-white {
				background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.6) 50%, rgba(255, 255, 255, 0.0) 100% ), linear-gradient(to bottom, rgba(255, 255, 255, 1.0), rgba(255, 255, 255, 0.0) 100% );
				opacity: 0.0;
			}
			.top-nav-solid-white {
				height: 98px;
				background-color: $white;
				background: linear-gradient(180deg, rgba(255,255,255,1) 0, rgba(255,255,255,1) 90px, rgba(0,0,0,0.20) 90px, rgba(0,0,0,0) 98px);
				opacity: 0.0;
			}
		}
		
		//When the nav is open, show the 'dark gradient'. It'll actually by solid blue due to other styles.
		&.open {
			.top-nav-gradient {
				opacity: 1.0;
			}
		}

		//When scrolled to the top, show the light or dark gradient (dark will be invisible, it'll just change the color of the text)
		&.is-shadowed.scrolled-top:not(.open) {
			&.background-is-light .top-nav-gradient-white {
				opacity: 1.0;
			}
		}	

		//When not scrolled to the top, always show the solid nav.
		&.is-shadowed:not(.scrolled-top):not(.open) {
			.top-nav-solid-white {
				opacity: 1.0;
			}
		}

		.search-icon-holder:focus, .user-icon-holder:focus, .menu-icon-holder:focus {
			outline: 1px dotted $white;
		}

		.top-nav-row {
			display: grid;

			.hamilton-logo {
				-ms-grid-column: 1;
				-ms-grid-row: 2;
			}
			.empty-space {
				-ms-grid-column: 2;
				-ms-grid-row: 2;
			}
			.search-icon-holder {
				-ms-grid-column: 3;
				-ms-grid-row: 2;
			}
			.user-icon-holder {
				-ms-grid-column: 4;
				-ms-grid-row: 2;
			}
			.menu-icon-holder {
				-ms-grid-column: 5;
				-ms-grid-row: 2;
			}
			-ms-grid-rows: 6px 55px 6px;
			grid-template-columns: 130px 1fr 35px 35px 35px;
			grid-gap: 6px;
			height: 55px;
			z-index: 20;

			@media (min-width: 350px) {
				grid-template-columns: 180px 1fr 45px 45px 45px;
			}

			@include respond-above(md) {
				grid-template-columns: 468px 1fr 52px 52px 52px;
				height: 80px;
			}	
			.bg-icon {
				z-index: 20;
			}			
		}

		&.search-open {

			.top-nav-search {
				display: flex;
				top: 0;

			}
			.top-nav-container {
				//top: 80px;
			}

		}

		&.open {
			// @include respond-above(lg) {
			// 	height: 100vh;	
			// }

			.menu-icon-holder .menu-icon {
				background-image: get-icon( 'close-icon', $white );
			}

			.menu-icon-holder:hover .menu-icon {
				background-image: get-icon( 'close-icon', $lightGrey2 );
			}

			.hamilton-logo {
				.hamilton-logo-text {
					display: none;
				}
				.hamilton-logo-section-name {
					display: none;
				}
			}
		
		}

		&.scrolled-top {
			.hamilton-logo {
				left: 15px;
			}
			.hamilton-logo-text {
				opacity: 1.0;
				width: 170px;
			}
			
		}

		// Make mobile menu 25px smaller in height
		@media (max-width: 767px) {
			&.is-shadowed {
				.top-nav-solid-white {
					height: 73px;
					background: linear-gradient(180deg, rgba(255,255,255,1) 0, rgba(255,255,255,1) 65px, rgba(0,0,0,0.20) 65px, rgba(0,0,0,0) 73px);
				}
			}

			.top-nav-gradient, .top-nav-gradient-white, .top-nav-solid-white {
				height: 65px;
			}
		}
	}
	.hamilton-logo .hamilton-logo-section-name {
		color: $white;
	}
	.hamilton-logo {
		display: flex;
		flex-direction: row;
		align-items: center;
		position: relative;
		transition: all 0.3s;
		left: 0px;

		&:focus {
			outline: none !important;

			.hamilton-logo-shape {
				outline: 1px dotted $white;
			}

			// .hamilton-logo-text {
			// 	outline: 1px dotted $white;
			// }

		}

		.hamilton-logo-shape {
			width: 45px;
			// width: 80%;
			height: 45px;
			margin-right: 10px;
			background-image: get-icon( 'hamilton-logo', $white );
			background-repeat: no-repeat;

			@include respond-below(lg) {
				width: 30px;
				height: 30px;

			}
		}

		.hamilton-logo-text {
			background-image: get-icon( 'hamilton-logo-text', $white );
			
			height: 20px;

			position: absolute;
			left: 55px;
			opacity: 0.0;
			transition: opacity 0.3s;

			@include respond-below(lg) {
				left: 45px;
				width: 120px;
				height: 14px;
			}

			@media (max-width: 400px) {
				width: 100px;
				height: 11px;
				left: 39px;
			}
		}

		.hamilton-logo-section-name {
			@include respond-below(sm) {
				width: 120px;
			}

			@media (max-width: 400px) {
				width: 100px;
			}
		}

		position: relative;
		// @include respond-above(md) {
		// 		width: 100%;
		// }
		&:hover {
			.hamilton-logo-shape {
				background-image: get-icon( 'hamilton-logo', $lightGrey2 );
			}

			.hamilton-logo-text {
				background-image: get-icon( 'hamilton-logo-text', $lightGrey2 );
			}
		}
	}


	.search-icon-holder {
	    display: flex;
	    align-items: center;
	    justify-content: center;

		.search-icon {
			background-image: get-icon( 'search-icon', $white );
			// width: 33px;
			width: 65%;
			height: 33px;
			position: relative;
			transition: transform 0.2s;
			@media (max-width: 400px) {
				height: 30px;
			}
			@include respond-above(md) {
				width: 100%;
			}
		}

		&:hover .search-icon {
			background-image: get-icon( 'search-icon', $lightGrey2 );
			transform: translateY(-3px);
		}
	}


	.user-icon-holder {
	    display: flex;
	    align-items: center;
	    justify-content: center;


		.user-login-icon {
			background-image: get-icon( 'user-login-icon', $white );
			// width: 34px;
			width: 65%;
			height: 34px;
			position: relative;
			transition: transform 0.2s;
			@include respond-above(md) {
				width: 100%;
			}
			@media (max-width: 400px) {
				height: 30px;
			}
		}

		&:hover .user-login-icon {
			background-image: get-icon( 'user-login-icon', $lightGrey2 );
			transform: translateY(-3px);
		}	
	}

	#hamburger-menu {
			padding: 0;			
	}

	.menu-icon-holder {
    	display: flex;
    	align-items: center;
    	justify-content: center;
		background: none;
		border: 0;

		@include respond-below(sm) {
			padding: 0 !important;
		}

		.menu-icon {
			background-image: get-icon( 'menu-icon', $white );
			
			width: 33px;
			height: 26px;
			position: relative;
			transition: transform 0.2s;
			@include respond-above(sm) {
				width: 37px;
			}
			@include respond-above(md) {
				
			}
			@media (max-width: 400px) {
				height: 25px;
			}

		}
		&:hover .menu-icon {
			background-image: get-icon( 'menu-icon', $lightGrey2 );
			transform: translateY(-3px);
		}
	}



	.top-nav.background-is-light:not(.open), .top-nav:not(.scrolled-top):not(.open) {
		.hamilton-logo {
			&:focus {
				outline: none !important;

				.hamilton-logo-shape {
					outline: 1px dotted $navyBlue;
				}

				// .hamilton-logo-text {
				// 	outline: 1px dotted $navyBlue;
				// }

			}
		}
		.search-icon-holder:focus, .user-icon-holder:focus, .menu-icon-holder:focus {
			outline: 1px dotted $navyBlue;
		}

		.hamilton-logo-shape {
			background-image: get-icon( 'hamilton-logo', $blueText );
		}
		.hamilton-logo-text {
			background-image: get-icon( 'hamilton-logo-text', $blueText );
		}

		.search-icon {
			background-image: get-icon( 'search-icon', $blueText );
		}
		.search-icon-holder:hover .search-icon {
			background-image: get-icon( 'search-icon', $lightBlue );
		}

		.user-login-icon {
			background-image: get-icon( 'user-login-icon', $blueText );
		}
		.user-icon-holder:hover .user-login-icon {
			background-image: get-icon( 'user-login-icon', $lightBlue );
		}

		.menu-icon {
			background-image: get-icon( 'menu-icon', $blueText );
		}
		.menu-icon-holder:hover .menu-icon {
			background-image: get-icon( 'menu-icon', $lightBlue );
		}

		.hamilton-logo .hamilton-logo-section-name {
			color: $black;
		}		

		.hamilton-logo:hover {
			.hamilton-logo-section-name {
				color: $lightBlue;
			}

			.hamilton-logo-text {
				background-image: get-icon( 'hamilton-logo-text', $lightBlue );
			}

			.hamilton-logo-shape {
				background-image: get-icon( 'hamilton-logo', $lightBlue );
			}
		}
	}
</style>
